import React from 'react';
import { PlusIcon } from 'lucide-react';
import { faqCategories } from '../data/faqs';
export function FaqSection() {
  return <section id="faq" aria-labelledby="faq-heading" className="w-full border-t border-line bg-white py-20 md:py-28" data-id="element-58" data-mp="1pl382ytpyxz8">
      <div className="mx-auto max-w-3xl px-6 md:px-12" data-id="element-59" data-mp="1gjlrzggbawaj">
        <div className="text-center" data-id="element-60" data-mp="1gketa1wi4tla">
          <h2 id="faq-heading" className="font-serif text-[1.9rem] leading-tight text-maroon md:text-[2.4rem]" data-id="element-61" data-mp="1glgbcqbxqgci">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 font-sans text-[14px] font-light leading-relaxed text-maroon-soft" data-id="element-62" data-mp="1ujeet0opwsd8">
            Everything about shipping, care, and ordering your 18K Gold pieces.
          </p>
        </div>

        <div className="mt-12 space-y-12" data-id="element-63" data-mp="2n826be028dz8">
          {faqCategories.map(category => <div key={category.id} id={category.id} className="scroll-mt-40" data-id="element-64" data-mp="2n67m61wm4pw7">
              <h3 className="font-sans text-[10px] uppercase tracking-luxe text-gold-deep" data-id="element-65" data-mp="2s03gmudo3umm">
                {category.title}
              </h3>
              <div className="mt-5 border-t border-line" data-id="element-66" data-mp="10u8k02123naf">
                {category.items.map(item => <details key={item.question} className="group border-b border-line" data-id="element-67" data-mp="1eldbuhy6nba7">
                    <summary className="flex cursor-pointer list-none items-center justify-between gap-6 py-4 font-serif text-[16px] font-light text-maroon transition-colors duration-150 ease-luxe hover:text-gold-deep [&::-webkit-details-marker]:hidden" data-id="element-68" data-mp="19sagc49uhrrd">
                      {item.question}
                      <PlusIcon className="h-4 w-4 shrink-0 text-gold transition-transform duration-200 ease-luxe group-open:rotate-45" strokeWidth={1.4} aria-hidden="true" data-id="element-69" data-mp="1xj6dlgx2lf60" />
                    </summary>
                    <p className="pb-5 pr-10 font-sans text-[14px] font-light leading-[1.8] text-maroon-soft" data-id="element-70" data-mp="3ue2hib6qpe7k">
                      {item.answer}
                    </p>
                  </details>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}